<template>
  <el-form ref="form" label-width="110px" label-position="left">
    <el-row v-if="model.adScheduleMacs && model.adScheduleMacs.length">
      <el-col>
        <el-form-item label="MAC定向">
          <div v-for="(item, index) in model.adScheduleMacs" :key="index">
            {{ item.beginMac }} - {{ item.endMac }}
          </div>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="model.adScheduleRegions && model.adScheduleRegions.length">
      <el-col>
        <el-form-item label="区域定向">
          <span v-for="(item, index) in model.adScheduleRegions" :key="'r' + index">
            {{ item }}
            <span v-if="index >= 0 && index < model.adScheduleRegions.length - 1">、</span>
          </span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="model.adScheduleDeviceSizes">
      <el-col>
        <el-form-item label="尺寸定向">{{ model.adScheduleDeviceSizes }}</el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="model.adTagDeviceList && model.adTagDeviceList.length">
      <el-col>
        <el-form-item label="品牌机型">
          <span v-for="(item, index) in model.adTagDeviceList" :key="'r' + index">
            {{ item }}
            <span v-if="index >= 0 && index < model.adTagDeviceList.length - 1">、</span>
          </span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="model.videoDeviceList && model.videoDeviceList.length">
      <el-col>
        <el-form-item label="视频源">
          <span v-for="(item, index) in model.videoDeviceList" :key="'r' + index">
            {{ item }}
            <span v-if="index >= 0 && index < model.videoDeviceList.length - 1">、</span>
          </span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="(model.customTagList && model.customTagList.length) ||
        (model.tagCustomTagList && model.tagCustomTagList.length) ||
        (model.lbsTagsList && model.lbsTagsList.length)"
    >
      <el-col>
        <el-form-item label="自定义标签">
          <template v-if="model.customTagList && model.customTagList.length">
            MAC包定向-{{model.customMatchRule === 'in' ? '定向所选标签' : '排除所选标签'}} -
            <span v-for="(item, index) in model.customTagList" :key="'m' + index">
              {{ item }}
              <span v-if="index >= 0 && index < model.customTagList.length - 1">、</span>
            </span>
          </template>
          <template v-if="model.tagCustomTagList && model.tagCustomTagList.length">
            机型定向- {{model.customMatchRule === 'in' ? '定向所选标签' : '排除所选标签'}} -
            <span v-for="(item, index) in model.tagCustomTagList" :key="'m' + index">
              {{ item }}
              <span v-if="index >= 0 && index < model.tagCustomTagList.length - 1">、</span>
            </span>
          </template>
          <template v-if="model.lbsTagsList && model.lbsTagsList.length">
            LBS定向- {{model.customMatchRule === 'in' ? '定向所选标签' : '排除所选标签'}} -
            <span v-for="(item, index) in model.lbsTagsList" :key="'m' + index">
              {{ item }}
              <span v-if="index >= 0 && index < model.lbsTagsList.length - 1">、</span>
            </span>
          </template>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="model.adScheduleDmps && model.adScheduleDmps.length">
      <el-col>
        <el-form-item label="DMP标签">
          {{$consts.dmpMatchText[model.dmpMatchType]}}
          <span v-for="(item, index) in model.adScheduleDmps" :key="'d' + index">
            {{ item.text }}
            <span v-if="index >= 0 && index < model.adScheduleDmps.length - 1">、</span>
          </span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="model.crowdList && model.crowdList.length">
      <el-col>
        <el-form-item label="广告DMP">
          <div>{{dx}}</div>
          <div>{{pc}}</div>
        </el-form-item>
      </el-col>
    </el-row>
    <template v-if="model.thirdDmpEntityList">
      <el-row v-for="(thirdDmp, index) in model.thirdDmpEntityList" :key="index">
        <el-col>
          <el-form-item :label="thirdDmp.componentName">{{ thirdDmp.componentMatchTypeName }} {{ thirdDmp.componentValue }}</el-form-item>
        </el-col>
      </el-row>
    </template>
    <template v-if="model.adScheduleBusinessSettings">
      <el-row v-for="(item, index) in model.adScheduleBusinessSettings" :key="'b' + index">
        <el-col>
          <el-form-item :label="item.componentName">
            <div style="word-break: break-all">{{ item.componentMatchTypeName }} {{ item.componentValue }}</div>
          </el-form-item>
        </el-col>
      </el-row>
    </template>
    <el-row v-if="model.adScheduleVideoTags && model.adScheduleVideoTags.length">
      <el-col>
        <el-form-item label="场景定向">
          <span v-for="(item, index) in model.adScheduleVideoTags" :key="'v' + index">
            <template v-if="item.classTypeName">{{ item.classTypeName }}</template>
            <template v-if="item.pkgName">- {{ item.pkgName }}</template>
            <template v-if="item.className">- {{ item.className }}</template>
            <span v-if="index >= 0 && index < model.adScheduleVideoTags.length - 1">、</span>
          </span>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    dx() {
      let res = this.model.crowdList.filter(item => item.matchType === 0).map(item => item.text).join('、')
      res = res ? `定向：${res}` : ''
      return res
    },
    pc() {
      let res = this.model.crowdList.filter(item => item.matchType === 2).map(item => item.text).join('、')
      res = res ? `排除：${res}` : ''
      return res
    }
  }
}
</script>

<style lang="stylus" scoped>
.el-form-item
  margin-bottom 0
</style>
